import HttpService from "./htttp.service";

class InfoService {
  // InfoEndpoint = process.env.API_URL;

  getPaymentInfo = async () => {
    const getPaymentInfo = "dash/info/payment";
    return await HttpService.get(getPaymentInfo);
  };

  editPaymentInfo = async (id, payload) => {
    const editPaymentInfo = `dash/info/payment/${id}`;
    return await HttpService.put(editPaymentInfo, payload);
  };
}

export default new InfoService();
